import PropTypes from "prop-types";
import { cn } from "@/lib/utils";
import { withoutBidiControls as plain } from "../snippets/bidi";
import { breachOverrides, breachText } from "./lib/target";

/**
 * A version's D5 cap breaches, each in plain words with its override
 * reasons (spec §5.4: "breaches are shown with their overrides") — on the
 * holdings involved, or the version's own for cash and the holding count.
 * Overrides and group names are agent-written: shown without their bidi
 * controls (D8).
 */
function TargetBreaches({ breaches, version, className }) {
  return (
    <ul aria-label="Cap breaches" className={cn("m-0 flex list-none flex-col gap-2 p-0", className)}>
      {breaches.map((breach, index) => (
        <li
          key={`${breach.cap}-${breach.subject}-${index}`}
          className="rounded-md border border-warning/60 bg-warning/10 px-3 py-2 text-sm"
        >
          <p className="m-0 font-medium wrap-anywhere">
            {breachText({ ...breach, subject: plain(breach.subject) })}
          </p>
          {breachOverrides(breach, version).map(({ symbol, text }) => (
            <p key={symbol ?? "version"} className="m-0 wrap-anywhere">
              {symbol ? `Override (${symbol}): ` : "Override: "}
              {text ? plain(text) : <span className="text-muted-foreground">none given</span>}
            </p>
          ))}
        </li>
      ))}
    </ul>
  );
}

TargetBreaches.propTypes = {
  breaches: PropTypes.arrayOf(
    PropTypes.shape({
      cap: PropTypes.string.isRequired,
      subject: PropTypes.string,
      limit: PropTypes.string,
      value: PropTypes.string,
      holdings: PropTypes.arrayOf(PropTypes.string),
    }),
  ).isRequired,
  /** The version the breaches belong to: its holdings' and its own override reasons. */
  version: PropTypes.shape({
    override_reason: PropTypes.string,
    holdings: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  className: PropTypes.string,
};

export default TargetBreaches;
